module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"cardRequired":"Kortnummer er påkrevd","expressCheckout":"Hurtigkasse"},"en":{"cardRequired":"Card number is required","expressCheckout":"Express Checkout"}}')
  delete Component.options._Ctor
}
